<template>
  <b-form-group>
    <label for="locked-institution-input">{{ $t("Institution") }}</label>

    <b-form-input id="locked-institution-input" :model-value="name" type="text" readonly disabled />
  </b-form-group>
</template>

<script lang="ts" setup>
defineProps<{
  name: string | null | undefined;
}>();
</script>
